import { Directive, Input, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[qtColumnFormatDef]',
  standalone: false,
})
export class ColumnFormatDirective {
  templateRef = inject<TemplateRef<any>>(TemplateRef);

  /** Column format of value. */
  @Input('qtColumnFormatDef') format: string;
}
